// Runtime overrides for build-time VITE_* values. In the Docker image, /env.js
// (generated at container start from the container environment) sets
// window.__APP_ENV__, so one admin image serves every whitelabel. Outside Docker
// (dev / the old pm2 deploy) nothing is set and import.meta.env applies.
const rt = (typeof window !== 'undefined' && window.__APP_ENV__) || {}
export const runtimeEnv = (key, fallback) => {
  const v = rt[key]
  return v != null && String(v).trim() !== '' ? String(v) : fallback
}
export const API_BASE_URL = runtimeEnv('VITE_API_BASE_URL', import.meta.env.VITE_API_BASE_URL || 'https://apidiamond99.codefactory.games/api')
export const PROJECT_NAME = runtimeEnv('VITE_PROJECT_NAME', import.meta.env.VITE_PROJECT_NAME || '')
